<template>
  <div class="bargain-active-index">
    <AUTHAPP></AUTHAPP>
  </div>
</template>
<script>
import LogisticsApi from '@/api/logistics.js';
import AUTHAPP from '@/views/auth_app/user/index';
export default {
   components: {
     AUTHAPP
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      roleList:{},
      user:{},
      /*搜索表单对象*/
      searchForm: {},
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*是否打开添加弹窗*/
      open_add: false,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1
    };
  },
  created() {
   this.logistics_id = this.$route.query.logistics_id;
    /*获取列表*/
   this.getData();
  },
  methods: {
    /*查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.logistics_id = self.logistics_id;
      LogisticsApi.accountList(Params, true)
        .then(res => {
          self.loading = false;
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
          self.user = res.data.user;
          self.roleList = res.data.roleList;
        })
        .catch(error => {});
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*打开添加*/
    addClick() {
      
        this.open_add=true;
      
    },

    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    /*添加体验者*/
    addTester() {
      let self = this;
      let Params = self.searchForm;
      PortApi.addTester(Params, true)
        .then(res => {
          self.loading = false;
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
        })
        .catch(error => {});
    },

    /*删除体验者*/
    deleteClick(e) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          LogisticsApi.deleteAccount(
            {
              shop_user_app_id: e,
              logistics_id:self.logistics_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/logistics/manager/part/test.vue